import store from '@/store'

function getTransitionAllowed (modeId) {
  const mode = store.getters['config/ALLOWED_MODES'][modeId]
  var value = false
  if (mode) {
    if (typeof mode.getTransitionAllowed === 'function') {
      value = !!mode.getTransitionAllowed(store)
    } else if (typeof mode.getTransitionAllowed === 'string') {
      value = !!store.getters[mode.getTransitionAllowed]
    } else value = !!mode.getTransitionAllowed
  }
  return value
}

function setTransitionAllowed (modeId, value) {
  const mode = store.getters['config/ALLOWED_MODES'][modeId]
  if (mode) {
    if (typeof mode.setTransitionAllowed === 'function') {
      mode.setTransitionAllowed(store, value)
    } else if (typeof mode.setTransitionAllowed === 'string') {
      if (mode.setTransitionAllowed.startsWith('dispatch:')) {
        const actionName = mode.setTransitionAllowed.replace('dispatch:', '')
        store.dispatch(actionName, value)
      } else {
        store.commit(mode.setTransitionAllowed, value)
      }
    }
  }
}

export { getTransitionAllowed, setTransitionAllowed }
